import { IconAssistant } from "@suse-o11y/icons";
import React from "react";

export const AssistantAvatar: React.FC = () => (
	<div className="flex size-8 shrink-0 items-center justify-center rounded-full border border-grey-300 bg-white">
		<IconAssistant className="size-5" />
	</div>
);
